import moment from 'moment-timezone'
export const fromTimestamp = function (v, e) {
  if (!v) {
    return null
  }
  // Display in the viewer's own local timezone, with an explicit zone
  // abbreviation so it's always clear which timezone is being shown.
  var d = moment.tz(v, moment.tz.guess()).format('LLLL z')
  return d
}

export { formatPhoneDisplay } from './phone'

/**
 * Normalizes various date formats to MM/DD/YYYY
 * Handles formats like: YYYY-MM-DD, MM-DD-YYYY, MM/DD/YYYY, YYYYMMDD, etc.
 * @param {string} dateString - The date string to format
 * @returns {string} Date in MM/DD/YYYY format or 'N/A' if invalid
 */
export const formatDateToMMDDYYYY = function (dateString) {
  if (!dateString) {
    return 'N/A'
  }

  // Common date formats to try parsing
  const formats = [
    'MM/DD/YYYY',
    'MM-DD-YYYY',
    'YYYY-MM-DD',
    'YYYYMMDD',
    'MM.DD.YYYY',
    'M/DD/YYYY',
    'M-DD-YYYY',
    'YYYY-MM-DDTHH:mm:ss.SSSZ',
  ]

  // Parse in UTC so the calendar date shown never shifts with the viewer's
  // local timezone — dateOfVasectomy/patientDob are logical calendar dates,
  // some stored as UTC-midnight ISO timestamps (see KitRequest.js comment).
  const date = moment.utc(dateString, formats, true)

  if (date.isValid()) {
    return date.format('MM/DD/YYYY')
  }

  // If none of the formats work, return N/A
  return 'N/A'
}

/**
 * Normalizes a date value — either an epoch ms timestamp (e.g. labTestedAt)
 * or a date string in one of the formats above — to a single display format
 * (e.g. "Jul 19, 2024"). Returns null for missing/unparseable values so
 * callers can render their own placeholder (e.g. '—').
 * @param {string|number} value
 * @returns {string|null}
 */
export const formatDisplayDate = function (value) {
  if (!value) {
    return null
  }

  const asNumber = Number(value)
  const date =
    !Number.isNaN(asNumber) && asNumber > 1e11
      ? moment(asNumber)
      : // Parsed in UTC, like formatDateToMMDDYYYY above, so a UTC-midnight ISO
        // string (see that function's comment) doesn't roll back a day for a
        // viewer west of UTC.
        moment.utc(
          value,
          ['MM/DD/YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD', 'YYYYMMDD', 'MM.DD.YYYY', 'M/DD/YYYY', 'M-DD-YYYY', 'YYYY-MM-DDTHH:mm:ss.SSSZ'],
          true
        )

  return date.isValid() ? date.format('MMM D, YYYY') : null
}
